import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Shade, ShadeSize } from '@ori/presentation-components';
import { useIsMobile } from '@ori/presentation-hooks';
import useTestId from '@ori/testid-generator';
import { MAX_MOBILE_VISIBLE_SHADES_COUNT, MAX_DESKTOP_VISIBLE_SHADES_COUNT, PRODUCT_BOX_SHADE_TEST_ID } from "./constants";
import { HiddenShadesCount, ShadesRoot } from "./styles";
import { SHADES } from "../../constants";
import { useProduct } from "../../hooks/internal";
import { filterDiscontinuedShade } from "../../utils/internal";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Shades = function Shades() {
  var _useTestId = useTestId(),
    getTestId = _useTestId.getTestId;
  var _useProduct = useProduct(),
    code = _useProduct.code,
    shades = _useProduct.shades;
  var isMobile = useIsMobile();
  var filteredShades = shades === null || shades === void 0 ? void 0 : shades.filter(filterDiscontinuedShade);
  if (!filteredShades || filteredShades.length < 2) {
    return null;
  }
  var maxVisibleShadesCount = isMobile ? MAX_MOBILE_VISIBLE_SHADES_COUNT : MAX_DESKTOP_VISIBLE_SHADES_COUNT;
  var elements = filteredShades.slice(0, maxVisibleShadesCount).map(function (shade) {
    return /*#__PURE__*/_jsx(Shade, {
      shade: _objectSpread({
        canBeSold: true
      }, shade),
      size: ShadeSize.Small,
      testId: PRODUCT_BOX_SHADE_TEST_ID
    }, shade.productCode);
  });
  return /*#__PURE__*/_jsxs(ShadesRoot, {
    "data-testid": "".concat(getTestId(SHADES), "-").concat(code),
    children: [elements, filteredShades.length > maxVisibleShadesCount ? /*#__PURE__*/_jsxs(HiddenShadesCount, {
      children: ["+", filteredShades.length - maxVisibleShadesCount]
    }) : null]
  });
};
export default Shades;
//# sourceMappingURL=Shades.js.map